import { makeStyles } from "@material-ui/core"

export const useStyles = makeStyles(() => ({
  subTitle: {
    marginTop: '30px',
    color: '#5A5A5A',
    fontSize: '16px',
    fontWeight: 'bold'
  },
  button: {
    width: '100px',
    height: '34px',
    margin: '0 8px',
    backgroundColor: 'white',
    border: '1px solid #B4B4B4',
    borderRadius: '17px',
    color: '#5A5A5A',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
  buttonSelected: {
    width: '100px',
    height: '34px',
    marginRight: '12px',
    backgroundColor: '#C4C7CE',
    border: '1px solid #B4B4B4',
    borderRadius: '17px',
    color: '#5A5A5A',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: '#C4C7CE',
      color: '#5A5A5A',
    },
    '&:focus': {
      backgroundColor: '#C4C7CE',
      color: '#5A5A5A',
    },
  },
  warningText: {
    marginTop: '40px',
    fontSize: '16px',
    color: '#5A5A5A',
  },
  inputsContainer: {
    display: 'flex',
    alignItems: 'end',
    margin: '20px 0',
  },
  inputContainer: {
    marginRight: '20px'
  },
  buttonSubmit: {
    width: '120px',
    height: '40px',
    marginLeft: '20px',
    backgroundColor: '#F68906',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '16px',
    textTransform: 'capitalize',

    '&:hover': {
      backgroundColor: '#F68906',
      color: 'white',
    }
  },
  buttonSubmitDisabled: {
    width: '120px',
    height: '40px',
    marginLeft: '20px',
    backgroundColor: '#70707033',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '16px',
    textTransform: 'capitalize',

    '&:hover': {
      backgroundColor: '#70707033',
      color: 'white',
    }
  },
  buttonPage: {
    marginRight: '12px',
    borderRadius: '12px',
    border: '2px solid #F68906',
    color: '#5A5A5A',
    fontWeight: 'bold',
    fontSize: '16px',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: 'white',
      color: '#5A5A5A',
    }
  }
}))

export const cardsStyles = makeStyles(() => ({
  title: {
    color: '#5A5A5A',
    fontSize: '26px',
    fontWeight: 'bold'
  },
  titleSection: {
    margin: '30px 0',
    fontSize: '20px',
    color: '#5A5A5A',
    fontWeight: '600',
  },
  sectionContainer: {
    maxWidth: '1800px',
    margin: '20px auto'
  },
  cardContainer: {
    height: '128px',
    marginRight: '20px',
    display: 'grid',
    gridTemplateColumns: '1fr 3fr',
    alignItems: 'center',
    background: '#FFFF',
    borderRadius: '7px',
    boxShadow: '0px 7px 12px #00000010',
    position: 'relative',
  },
  icon: {
    width: 43,
    height: 43,
    marginLeft: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '34px',
    fontWeight: '600',
    color: 'white',
    borderRadius: '50%',
    backgroundColor: '#E2A233',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  iconImage: {
    width: 43,
    height: 43,
    marginLeft: 20,
    color: 'white',
    borderRadius: '50%',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  textContainer: {
    display: 'flex',
    marginLeft: '12px',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  titleCard: {
    fontSize: '16px',
    color: '#5A5A5A',
    fontWeight: 'bold',
    textAlign: 'left',
    letterSpacing: 0.8,
  },
  amount: {
    fontSize: 29,
    fontWeight: 'bold',
    color: '#2B2B2B',
    textAlign: 'left',
  },
  percent: {
    position: 'absolute',
    bottom: 0,
    right: 20,
    color: '#F68906',
    fontSize: '21px',
    fontWeight: 400,
  }
}))


export const regionsStyles = makeStyles(() => ({
  title: {
    color: '#5A5A5A',
    fontSize: '26px',
    fontWeight: 'bold',
    marginBottom: '30px'
  }
}))

export const bossesStyles = makeStyles(() => ({
  title: {
    color: '#5A5A5A',
    fontSize: '26px',
    fontWeight: 'bold',
    marginBottom: '30px'
  }
}))

export const dinamicTablesStyles = makeStyles(() => ({
  container: {
    padding: '40px'
  },
  title: {
    color: '#5A5A5A',
    fontSize: '26px',
    fontWeight: 'bold',
    marginBottom: '30px'
  },
  head: {
    backgroundColor: '#F6F6F6',
    textAlign: 'center',
  },
  rowHead: {
    '& .MuiTableCell-head': {
      color: '#5A5A5A',
      fontWeight: 600,
    }
  },
  body: {
    '& .MuiTableCell-body': {
      color: '#5A5A5A',
    },
    '& .MuiTableCell-root': {
      fontWeight: 600,
      fontSize: '16px',
      fontFamily: 'Nunito, Roboto'
    }
  },
  centeredCell: {
    textAlign: 'center'
  },
  containerQuizzesFilters: {
    display: 'flex',
    alignItems: 'center'
  },
  tableContainer: {
     marginTop: '20px'
  },
  select: {
    width: '200px',
    marginRight: '50px'
  },
  btnSelected: {
    margin: '0 8px',
    color: '#5A5A5A',
    backgroundColor: '#E1E1E1',
    border: '1px solid #B4B4B4',
    borderRadius: '17px',
    letterSpacing: '1.2px',
    fontWeight: 600,
    textTransform: 'none',
    '&:hover': {
      color: '#5A5A5A',
      backgroundColor: '#E1E1E1',
      border: '1px solid #B4B4B4',
    }
  },
  btnFilter: {
    margin: '0 8px',
    color: '#5A5A5A',
    backgroundColor: '##cbc4cb',
    borderRadius: '17px',
    border: '1px solid #B4B4B4',
    letterSpacing: '1.2px',
    fontWeight: 600,
    textTransform: 'none',
    '&:focus': {
      color: '#5A5A5A',
      backgroundColor: '#E1E1E1',
      border: '1px solid #B4B4B4',
    }
  }
}))

